import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import AddAccount from './pages/AddAccount/AddAccount';
import Accounts from './pages/Accounts/Accounts';
import NotFound from './pages/NotFound/NotFound';

const Routes: React.FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Redirect to="/accounts" />}
          />
          <Route exact path="/accounts/:category" component={Accounts} />
          <Route exact path="/accounts" component={Accounts} />
          <Route exact path="/add-account" component={AddAccount} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </Suspense>
  );
};

export default Routes;
